<template>
  <div>
    <CForm @submit.prevent="searchKeyword">
      <CModal
        centered
        :close-on-backdrop="false"
        :show.sync="properties.visible"
      >
        <template #header>
          <h5 class="modal-title">장소검색</h5>
          <CButtonClose @click="properties.visible = false"></CButtonClose>
        </template>

        <div role="group" class="mb-0 w-100 form-group">
          <div class="input-group">
            <div class="input-group-prepend" v-if="!search.isReadonly">
              <button
                class="btn btn-outline-secondary"
                type="button"
                @click="changeView('map')"
              >
                <i class="fa fa-angle-left" aria-hidden="true"></i>
              </button>
            </div>
            <input
              type="text"
              placeholder="장소검색"
              autocomplete="off"
              class="form-control"
              :style="search.isReadonly ? '' : ''"
              :readonly="search.isReadonly"
              v-model="search.request.query"
              @click="changeView('mapSearch')"
            />

            <div class="input-group-append">
              <button
                type="submit"
                class="btn btn-outline-secondary"
                :disabled="search.isReadonly"
              >
                <i class="fa fa-search" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>

        <div :style="'min-height: ' + minHeight + ';'" class="mt-3">
          <div
            ref="map"
            :class="viewType !== 'map' ? 'd-none' : ''"
            class="h-100"
            :style="'min-height: ' + minHeight + ';'"
          >
            <div
              style="
                position: absolute;
                z-index: 10;
                background: rgba(0, 0, 0, 0.6);
                padding: 5px 10px 5px 10px;
                width: 100%;
                text-align: center;
                color: #ffffff;
              "
            >
              지도를 움직여 원하는 위치를 지정하세요.
            </div>
            <div
              v-if="isHttps"
              style="
                position: absolute;
                z-index: 10;
                margin-top: 40px;
                padding: 5px 10px 5px 10px;
                width: 100%;
                text-align: right;
                color: #ffffff;
              "
            >
              <button
                class="btn btn-light"
                @click="currentPosition"
                style="
                  width: 40px;
                  height: 40px;
                  padding: 0;
                  border-radius: 25px;
                  border: 1px solid #a8a8a8;
                "
              >
                <i
                  class="flaticon flaticon-gps"
                  :class="searchMyLocation ? 'fa-spin text-primary' : ''"
                  style="font-size: 25px; width: 24px; height: 24px"
                ></i>
              </button>
            </div>
            <div
              v-if="map.addressText != null"
              style="
                position: absolute;
                z-index: 10;
                background: rgba(0, 0, 0, 0.6);
                padding: 5px 10px 5px 10px;
                width: 100%;
                text-align: center;
                color: #ffffff;
                bottom: 0;
              "
            >
              <div v-if="searchMyLocation">현재 내 위치를 찾고 있습니다.</div>
              <div v-else>
                {{ map.addressText }}
              </div>
            </div>
          </div>
          <div
            ref="mapSearch"
            :class="viewType !== 'mapSearch' ? 'd-none' : ''"
            class="h-100"
          >
            <CListGroup v-if="search.item.list.length > 0">
              <CListGroupItem
                v-for="(item, i) in search.item.list"
                :key="i"
                tag="button"
                @click="selectSearchItem(item)"
              >
                {{ item.placeName }}
                <div class="figure-caption">
                  {{ item.addressName }}
                </div>
              </CListGroupItem>
            </CListGroup>
            <div v-else>정보가 없습니다</div>
          </div>
        </div>

        <template #footer>
          <CButton @click="properties.visible = false" color="secondary">
            취소
          </CButton>
          <CButton color="success" @click="confirm()" v-if="viewType === 'map'">
            완료
          </CButton>
        </template>
      </CModal>
    </CForm>
  </div>
</template>

<script>
import MixinsModalBackButton from "@/mixins/modal-back-button";
import store from "@/store";
import CoreKakaoMap from "@/core/core-kakao-map";
import core from "@/core";

export default {
  name: "SearchAddressModal",
  mixins: [MixinsModalBackButton()],
  components: {},
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          visible: false,
          params: {
            loadMyLocation: false,
          },
          watchClose: {
            result: "",
            item: null,
          },
        };
      },
    },
  },
  data() {
    return {
      app: store.state.app,
      minHeight: "400px",
      viewType: "map",
      updateViewType: null,
      searchMyLocation: false,
      map: {
        addressText: null,
        default: {
          address: "선택된 위치가 없습니다",
          latitude: 37.5653888,
          longitude: 126.9783866,
          level: 6,
        },
      },

      search: {
        isLoading: false,
        isReadonly: true,
        item: {
          meta: {},
          list: [],
        },
        request: {
          page: 1,
          size: 10,
          query: "",
        },
        event: {
          nextLoadFlag: false,
        },
      },

      locationResult: {
        address1: null,
        address2: null,
        latitude: null,
        longitude: null,
      },

      kakaoMap: null,
      isHttps: false,
    };
  },
  created() {
    this.search.request.size = Math.ceil((window.innerHeight - 56) / 64) + 5;
  },
  mounted() {
    this.$nextTick(() => {
      this.isHttps = window.location.protocol.indexOf("https") > -1;

      if (window.innerHeight < 400 + 230) {
        this.minHeight = window.innerHeight - 230 + "px";
      }

      // 처음 화면 렌더링 될경우 지도 생성
      const query = this.$route.query;
      if (
        query.latitude != null &&
        query.longitude != null &&
        query.address1 != null
      ) {
        let level = Number(query.level);
        if (level < 1) level = 2;
        const location = {
          address1: query.address1,
          address2: query.address2,
          latitude: query.latitude,
          longitude: query.longitude,
          level: level,
        };
        this.initMap(location);
      } else {
        const defaultLocation = this.map.default;
        const location = {
          address1: defaultLocation.address,
          latitude: defaultLocation.latitude,
          longitude: defaultLocation.longitude,
          level: defaultLocation.level,
        };
        this.initMap(location);
      }
    });
  },
  watch: {
    "search.event.nextLoadFlag"() {
      if (this.search.event.nextLoadFlag) {
        this.searchKeyword();
      }
    },
  },
  updated() {
    const updateViewType = this.updateViewType;
    this.updateViewType = null;
    const kakaoMap = this.kakaoMap;
    if (updateViewType === "map") {
      const location = this.locationResult;
      kakaoMap.relayout();
      if (location.latitude != null && location.longitude != null) {
        kakaoMap.setCenterAndLevel(
          Number(location.latitude),
          Number(location.longitude),
          2,
        );
      }
    }
  },
  methods: {
    confirm() {
      if (this.locationResult == null || this.locationResult.latitude == null) {
        core.alert.show({
          title: "알림",
          icon: "error",
          body: "선택된 위치가 없습니다",
        });
      } else {
        this.properties.watchClose = {
          result: "confirm",
          item: this.locationResult,
        };
        this.properties.visible = false;
      }
    },
    changeView(viewType) {
      //console.log("viewType : ", viewType);
      this.viewType = viewType;

      if (viewType === "map") {
        // 지도 레이아웃이 렌더링 될때 처리하기 위함
        this.updateViewType = "map";
        this.search.isReadonly = true;
      } else if (viewType === "mapSearch") {
        this.search.isReadonly = false;
      } else {
        console.log("unknown viewType : ", viewType);
      }
    },
    currentPosition() {
      if (this.searchMyLocation) {
        this.searchMyLocation = false;
      } else {
        this.searchMyLocation = true;

        const kakaoMap = this.kakaoMap;
        core.location
          .currentPosition()
          .then((location) => {
            //console.log('location : ', location);
            this.map.default.latitude = location.latitude;
            this.map.default.longitude = location.longitude;

            if (this.searchMyLocation) {
              this.searchMyLocation = false;
              kakaoMap
                .changeAddressByLocation(
                  location.latitude,
                  location.longitude,
                  false,
                )
                .then((data) => {
                  this.map.addressText = data?.fullAddress;
                  this.locationResult.address1 = data?.address;
                  this.locationResult.address2 = data?.buildingName;
                  this.locationResult.latitude = data?.latitude;
                  this.locationResult.longitude = data?.longitude;
                  kakaoMap.setCenter(location.latitude, location.longitude);
                })
                .catch((reason) => {
                  console.log(reason);
                });
            }
          })
          .catch((reason) => {
            this.searchMyLocation = false;
          });
      }
    },
    searchKeyword() {
      const kakaoMap = this.kakaoMap;
      const search = this.search;
      search.isReadonly = true;
      const query = search.request.query;
      if (query.length > 0) {
        this.search.isLoading = true;
        if (search.event.nextLoadFlag) {
          search.request.page++;
        } else {
          search.request.page = 1;
          search.item.list = [];
          search.item.meta = {};
        }
        kakaoMap
          .searchKeyword(search.request)
          .then((res) => {
            if (search.event.nextLoadFlag) {
              res.list.forEach((data) => {
                search.item.list.push(data);
              });
              search.item.meta = res.meta;
              search.event.nextLoadFlag = false;
            } else {
              search.item = res;
            }
            search.isLoading = false;
            search.isReadonly = false;
          })
          .catch((reason) => {
            search.isLoading = false;
            search.isReadonly = false;
            search.event.nextLoadFlag = false;
          });
      }
    },
    selectSearchItem(item) {
      const location = {
        address:
          item.roadAddressName != null && item.roadAddressName.length > 0
            ? item.roadAddressName
            : item.addressName,
        latitude: item.latitude,
        longitude: item.longitude,
        buildingName: item.placeName != null ? item.placeName : "",
      };
      if (location.buildingName.length > 0) {
        location.fullAddress = `${location.address}(${location.buildingName})`;
      } else {
        location.fullAddress = location.address;
      }

      console.log("selectSearchItem : ", item);
      // this.search.request.query

      this.locationResult.address1 = location.address;
      this.locationResult.address2 = location.buildingName;
      this.locationResult.latitude = location.latitude;
      this.locationResult.longitude = location.longitude;

      this.changeView("map");
      this.map.addressText = location.fullAddress;
    },
    async initMap(params) {
      console.log("init map");
      const mapData = this.map;
      let address = params.address1;
      if (params.address2 != null) {
        address += `(${params.address2})`;
      }
      mapData.addressText = address;
      const mapElement = this.$refs.map;
      // const mapChangeEvent = {
      //   preStatus: "",
      //   preDate: new Date(),
      // };

      const locationItem = {
        changeTime: null,
        interval: null,
        latitude: null,
        longitude: null,
      };

      const locationResult = this.locationResult;

      const kakaoMap = (this.kakaoMap = new CoreKakaoMap({
        map: {
          element: mapElement,
          option: {
            center: new kakao.maps.LatLng(params.latitude, params.longitude),
            level: params.level,
          },
          view: "selectLocation",
        },
        callback: {
          centerChanged(loc) {
            if (
              locationItem.latitude != null &&
              locationItem.longitude == loc.latitude &&
              locationItem.longitude == loc.longitude
            ) {
              console.log("동일 위치 중앙이동");
              return;
            }
            locationItem.latitude = loc.latitude;
            locationItem.longitude = loc.longitude;
            locationItem.changeTime = new Date();

            if (locationItem.interval == null) {
              mapData.addressText = "지도 이동 중";
              locationItem.interval = setInterval(() => {
                const curTime = new Date();
                if (
                  curTime.getTime() - locationItem.changeTime.getTime() >
                  100
                ) {
                  clearInterval(locationItem.interval);
                  locationItem.interval = null;
                  locationItem.changeTime = null;

                  kakaoMap
                    .changeAddressByLocation(
                      locationItem.latitude,
                      locationItem.longitude,
                      false,
                    )
                    .then((location) => {
                      mapData.addressText = location?.fullAddress;

                      locationResult.address1 = location?.address;
                      locationResult.address2 = location?.buildingName;
                      locationResult.latitude = location?.latitude;
                      locationResult.longitude = location?.longitude;
                    })
                    .catch((reason) => {
                      console.log(reason);
                    });
                }
              }, 500);
            }
          },
          dragEnd() {
            // 드래그 종료시
            locationItem.changeTime = new Date(new Date().getTime() - 5000);
          },
          zoomChanged() {
            // 줌 변경시
            locationItem.changeTime = new Date(new Date().getTime() - 5000);
          },
        },
      }));

      if (this.properties.params.loadMyLocation && this.isHttps) {
        const result = await core.alert.show({
          title: "확인",
          body: "현재 내 위치로 이동하시겠습니까?",
          showCancelButton: true,
        });
        if (result === "confirm") {
          this.currentPosition();
        }
      }
    },
  },
};
</script>
